<template>
  <div></div>
</template>

<script>
import axios from "axios";
import { userMixin } from "@/mixins/user";

export default {
  name: "AuthCallback",
  mixins: [userMixin],

  data() {
    return {
      code: false,
    };
  },

  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const VUE_APP_URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
    console.log("ICI", code);
    if (code) {
      // On appelle le backend pour échanger le code contre les tokens
      axios
        .post(
          VUE_APP_URL_BACKEND + "api-user/token/rotate-all/",
          {},
          {
            headers: {
              Authorization: `Bearer ${code}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          const { access_token, refresh_token } = response.data;
          this.$cookies.set("access_token", access_token);
          this.$cookies.set("refresh_token", refresh_token);
          this.userRetrieve();
          this.$router.push({ name: "home" });
        })
        .catch((error) => {
          console.error("Erreur lors de l'échange du code :", error);
          // Rediriger vers login en cas d'échec
          this.$router.push({ name: "logout" });
        });
    } else {
      // Si pas de code dans l'URL, on redirige vers la page login
      this.$router.push({ name: "login" });
    }
  },
};
</script>
